import React from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';


const PopupText = styled.span`
  font-family: 'Titillium Web', sans-serif;
`;

const Overlay = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);

  @media(min-width: 1000px) {
    width: 100%;
  }
`;

const Popup = styled.div`
  background-color: #fff;
  border-radius: 16px;
  position: relative;
  margin: 8px;
  @media(min-width: 1000px) {
    width: 784px;
    display: block;
    margin-top: 22px;
    overflow: hidden;
  }
`;

const CloseButton = styled.a`
  width: 24px;
  height: 24px;
  object-fit: contain;
  position: absolute;
  top: 24px;
  right: 24px;
  border: none;
  cursor: pointer;
  z-index: 50;
`;

const PopupImage = styled.img`
  width: 343px;
  height: 702px;
  position: absolute;
  top: 32px;
  right: 0px;
  display: none;
  @media(min-width: 1000px) {
    display: block;
  }
`;

const Header = styled.div`
  background-color: #414056;
  border-bottom: solid 1px #979797;
  font-weight: bold;
  color: #ffffff;
  border-radius: 16px 16px 0 0;
`;

const Brand = styled.div`
  padding: 24px 24px 0 24px;
  display: flex;
  align-items: center;
  @media(min-width: 1000px) {
    padding: 40px 0 36px 40px;
  }
`;

const Logo = styled.img`
  height: 31px;
  width: 31px;
  object-fit: contain;
`;

const PRO = styled.span`
  font-size: 14px;
  margin: 10px;
`;

const HeaderText = styled(PopupText)`
  font-size: 24px;
  display:inline-block;
  padding: 24px;
  line-height: 1.17;
  @media(min-width: 1000px) {
    font-size: 36px;
    max-width: 440px;
    padding: 0 0 36px 40px;
    line-height: 1;
  }
`;

const Content = styled.div`
  background-color: #fff;
  border-radius: 0 0 16px 16px;
  padding: 0px;
  @media(min-width: 1000px) {
    max-width: 440px;
    padding: 8px;
  }
`;

const Advantage = styled.div`
  color: #414056;
  padding: 5px 24px;
  text-align: left;
  @media(min-width: 1000px) {
    padding: 16px 40px;
  }
`;

const AdvantageTitle = styled(PopupText)`
  opacity: 0.7;
  font-size: 20px;
  font-weight: bold;
  display: block;
  margin: 8px 0;
  @media(min-width: 1000px) {
    font-size: 24px;
  }
`;

const AdvantageText = styled(PopupText)`
  opacity: 0.7;
  font-size: 14px;
  line-height: 1.25;
  display: block;
  margin-top: 8px;
  @media(min-width: 1000px) {
    font-size: 16px;
  }
`;

const LineBar = styled.hr`
  width: 53px;
  height: 2px;
  background-color: #c2a061;
  border: none;
  align-content: left;
  margin-left: 0;
`;

const OlxProPopup = ({ onClose }) => (
  <Overlay data-e2e="olx-pro-modal" onClick={onClose}>
    <Popup onClick={e => e.stopPropagation()}>
      <Header>
        <CloseButton data-e2e="olx-pro-modal-close" onClick={onClose}>
          <img src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="fechar" />
        </CloseButton>
        <Brand>
          <Logo src={`${process.env.PUBLIC_URL}/images/logo-min.svg`} alt="OLX" />
          <PRO>PRO</PRO>
        </Brand>
        <HeaderText>Venda muito mais e tenha tudo sobre seus anúncios em um mesmo lugar.</HeaderText>
      </Header>
      <Content>
        <Advantage>
          <LineBar />
          <AdvantageTitle>Performance</AdvantageTitle>
          <AdvantageText>Aumente seu alcance e visualize exatamente quantos contatos por chat, telefone e e-mail seus anúncios receberam.</AdvantageText>
        </Advantage>
        <Advantage>
          <LineBar />
          <AdvantageTitle>Visibilidade</AdvantageTitle>
          <AdvantageText>Tenha todo o seu estoque reunido, gerencie por loja e saiba o status de cada uma das suas publicações.</AdvantageText>
        </Advantage>
        <Advantage>
          <LineBar />
          <AdvantageTitle>Atendimento</AdvantageTitle>
          <AdvantageText>Acesse o OLX Pro com o seu login OLX e tenha um canal exclusivo de atendimento conosco.</AdvantageText>
        </Advantage>
      </Content>
      <PopupImage src={`${process.env.PUBLIC_URL}/images/abertura-landing.png`} />
    </Popup>
  </Overlay>
);

OlxProPopup.propTypes = {
  onClose: func.isRequired,
};

export default OlxProPopup;
